import { Button } from "@peer-start/ui";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@peer-start/ui/reducate";
import { useTranslation } from "react-i18next";

export function SituationConfirmDialog({
  title,
  body,
  confirmLabel,
  cancelLabel,
  destructive = false,
  pending,
  onConfirm,
  onCancel,
}: {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      onOpenChange={(open) => {
        if (!open && !pending) onCancel();
      }}
      open
    >
      <DialogContent className="sm:max-w-md" closeLabel={t("common.close")} showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{body}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            controlId="situation.confirm.cancel"
            disabled={pending}
            onClick={onCancel}
            type="button"
            variant="secondary"
          >
            {cancelLabel ?? t("administration.situationCard.cancel")}
          </Button>
          <Button
            className={
              destructive
                ? "border-transparent! bg-[var(--destructive-solid)]! text-inverse! shadow-xs! hover:bg-[var(--destructive-solid)]!"
                : ""
            }
            controlId="situation.confirm.submit"
            disabled={pending}
            onClick={onConfirm}
            type="button"
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
